<template>
    <div class="wizard-select-course">
        <div class="text-center my-12">
            <h3>{{ $trans.get("wizard.step1.title") }}</h3>
            <div class="btns">
                <button
                    id="btn-presential"
                    class="btn"
                    :class="{ selected: show_online }"
                    @click="show_online = false"
                >
                   {{$trans.get('wizard.step1.face-to-face')}}
                </button>
                <button
                    id="btn-online"
                    class="btn"
                    :class="{ selected: !show_online }"
                    @click="show_online = true"
                >
                    Online
                </button>
            </div>
        </div>
        <div class="grid-select-course">
            <card-courses
                v-for="(course, index) in coursesFiltered"
                :key="index"
                hover
               @click.native="selectCourse(course)"
                class="cursor-pointer relative"
                :class="getNotEnrolableCourse(course)"
            >
                <div :class="'status ' + getStatusClass(course)">
                    <span>{{ getStatusText(course) }}</span>
                </div>
                <div v-if="!getNotEnrolableCourse(course) && course.show_places == 1" class="status status-last-places">
                    <span>{{ $trans.get('wizard.step1.places1') + course.places + $trans.get('wizard.step1.places2')  }}</span>
                </div>
                <div>
                    <div class="min-height">
                        <p>{{ course.type === 'other' ? "Cursos" : course.type }}</p>
                        <h5>{{ course.name[$store.state.locale] }}</h5>
                    </div>
                    <div v-if="course.price_to_consult">
                        <hr class="mb-3 mt-12" />
                        <p class="text-blue">
                            {{ $trans.get("wizard.step1.consult") }}
                        </p>
                    </div>
                    <div v-else>
                        <hr class="mb-3 mt-12" />
                        <div v-if="!show_online">
                            <div v-if="course.years != 1">
                                <p class="text-blue">
                                    {{ $trans.get("wizard.step1.totalprice") }}:
                                    {{ totalPrice(course) | currency }}
                                </p>
                                <p
                                    >({{ partialPrice(course) | currency }}
                                    {{
                                        $trans.get("wizard.step1.percourse")
                                    }})</p
                                >
                            </div>
                            <div v-else>
                                <p
                                    v-if="
                                        course.years == 1 &&
                                            !course.price_to_consult
                                    "
                                    class="text-blue"
                                >
                                    {{ totalPrice(course) | currency }}
                                    {{ $trans.get("wizard.step1.otherprice") }}
                                </p>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="course.years != 1">
                                <p class="text-blue">
                                    {{ totalPrice(course) | currency }}<br/>
                                    {{ $trans.get("wizard.step1.totalprice") }}
                                </p>
                            </div>
                            <div v-else>
                                <p v-if="course.years == 1 && !course.price_to_consult" class="text-blue">
                                    {{ totalPrice(course) | currency }}
                                    {{ $trans.get("wizard.step1.otherprice") }}
                                </p>
                            </div>
                        </div>
                        <div class="status-sold-out" v-if="!course.enrolable">
                            <span>{{ $trans.get("wizard.step1.sold-out") }}</span>
                        </div>
                    </div>
                </div>
            </card-courses>
        </div>
    </div>
</template>
<script>
import CardCourses from "../components/CardCourses.vue";
import { mapGetters } from "vuex";

export default {
    components: { CardCourses },
    computed: {
        ...mapGetters({
            courses: "getCourses"
        }),
        coursesFiltered() {
            return this.show_online ? this.coursesOnline : this.coursesPresential;
            
        },
        coursesOnline() {
            return this.courses?.filter(c => c.online);
        },
        coursesPresential(){
            return this.courses?.filter(c => !c.online)
        },
    },

    data() {
        return {
            show_online: false,
            statusColors: {
                'closed': 'status-closed',
                'march-openning': 'status-march',
                'sold-out-places': 'status-full',
                'open': 'status-open',
                'last-places': 'status-last-places'
            },
            statusTexts: {
                'closed': this.$trans.get("wizard.step1.closed"),
                'march-openning': this.$trans.get("wizard.step1.march"),
                'sold-out-places': this.$trans.get("wizard.step1.full"),
                'open': this.$trans.get("wizard.step1.open"),
                'last-places': this.$trans.get('wizard.step1.places1')  + this.$trans.get('wizard.step1.places2') 
            }

        };
    },

    methods: {
        setShowOnline(value) {
            this.show_online = value;
        },
        partialPrice(course) {
            return course.total_price / course.years;
        },
        selectCourse(course) {
            this.$store.commit("setSelected", {
                prop: "course",
                value: {
                    ...course,
                    type_selected: this.show_online ? true : false
                }
            });
        },
        totalPrice(course) {
            return Math.trunc(course.total_price);
        },
        partialPrice(course) {
            return course.total_price / course.years;
        },
        selectCourse(course) {
            this.$store.commit("setSelected", {
                prop: "course",
                value: {
                    ...course,
                    type_selected: this.show_online ? "online" : "presencial"
                }
            });
            this.$router.push({ name: "modalidad-de-pago" });
        },
        getNotEnrolableCourse(course) {
            if (!course.enrolable || course.status === 'closed' || course.status === 'march-openning' || course.status === 'sold-out-places') 
                return 'disabled';
        },
        getStatusClass(course) {
            return this.statusColors[course.status] || 'status-open';
        },
        getStatusText(course) {
            return this.statusTexts[course.status] || this.$trans.get("wizard.step1.open");
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../../sass/_variables.scss";
.btns {
    margin-top: 1.5rem;

    .btn {
        height: 50px;
        border: 4px solid #0f304d;
        cursor: pointer;
        font-size: 1rem;
        font-weight: bold;
        padding: 5px 30px;
        background-color: #fff;
    }
    .btn:hover {
        transform: unset;
    }
    .selected {
        background-color: #0f304d;
        color: #fff;
    }
    
    #btn-presential {
        margin-right: -5px;
    }
    #btn-online {
        margin-left: -5px;
    }
}

.grid-select-course {
    padding-bottom: 3rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, 320px);
    grid-gap: 20px;
    justify-content: center;
    .wizard-courses-card {
        margin-bottom: 1rem;
        height: 100%;
        width: 320px;

        .min-height {
            @media (min-width: 1024px) {
                min-height: 110px;
            }
        }

        @media (min-width: 1024px) {
            margin-bottom: 0rem;
        }

        .status {
            position: absolute;
            border-radius: 6px;
            height: 32px;
            padding: 0 10px;
            top: 10px;
            right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                color: #000;
                font-size: 14px;
            }
            
            @each $status, $color in $status-color {
                &-#{$status} {
                    background-color: $color;
                }
            }

        }
   
    }
}
</style>
